<template>
  <iColumn align="center">
    <iRow>
      <iText font-size="large">
        Continue as:
      </iText>
    </iRow>
    <iRow
      v-for="lastLoggedInUser in lastLoggedInUsers"
      :key="lastLoggedInUser.user_id"
      align="center"
      vertical-align="middle"
      wrap="nowrap"
      cursor="pointer"
      :style-overrides="{
        borderWidth: 'standard',
        borderRadius: 'large',
        borderColor: 'standard',
        paddingTop: 'extraSmall',
        paddingBottom: 'extraSmall',
        paddingLeft: 'extraSmall',
        paddingRight: 'extraSmall',
      }"
      @click="finalizeLogin(lastLoggedInUser)"
    >
      <iRow
        :width="35"
        :height="35"
        :min-width="35"
        :max-width="35"
        :style-overrides="{
          marginLeft: 'standard',
          marginRight: 'standard',
        }"
      >
        <AvatarImage :src="lastLoggedInUser.avatar_url" size="35px" background-color="grey.100" />
      </iRow>
      <iColumn gap="thin" width="fill">
        <iText>{{ lastLoggedInUser.first_name }} {{ lastLoggedInUser.last_name }} </iText>
        <iText variant="subtle" font-size="small">
          {{ lastLoggedInUser.email_data.email_address }}
        </iText>
      </iColumn>
      <iIcon
        icon="caret-right"
        :disable-hover-effect="true"
        :style-overrides="{
          marginRight: 'standard',
        }"
      />
    </iRow>

    <iRow
      align="center"
      vertical-align="middle"
      wrap="nowrap"
      cursor="pointer"
      :min-height="59"
      :style-overrides="{
        borderWidth: 'standard',
        borderRadius: 'large',
        borderColor: 'standard',
        paddingTop: 'extraSmall',
        paddingBottom: 'extraSmall',
        paddingLeft: 'extraSmall',
        paddingRight: 'extraSmall',
      }"
      @click="useDifferentEmail"
    >
      <iRow
        :width="35"
        :height="35"
        :min-width="35"
        :max-width="35"
        :style-overrides="{
          marginLeft: 'standard',
          marginRight: 'standard',
        }"
      >
        <AvatarImage :src="DEFAULT_USER_AVATAR" size="35px" background-color="grey.100" />
      </iRow>
      <iColumn gap="thin">
        <iText>Use another account</iText>
      </iColumn>
    </iRow>

    <iText v-if="signupErrorMessage" variant="error">
      {{ signupErrorMessage }}
    </iText>

    <iSpace :height="40" width="fill" />
    <PoweredByInspiration />
  </iColumn>
</template>

<script>
import { mapState, mapWritableState } from "pinia";
import PoweredByInspiration from "%/dynamic-component-editor/standard-pages/login-signup-page/join-publication/PoweredByInspiration.vue";
import AvatarImage from "%/dynamic-component-editor/components/AvatarImage.vue";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { useLoginSignupStore } from "%/dynamic-component-editor/stores/login-signup-store";
import { EMAIL_FORM, PASSWORD_FORM } from "%/dynamic-component-editor/constants/login-flow-constants";
import { DEFAULT_USER_AVATAR } from "%/dynamic-component-editor/constants/user-constants";

export default {
  name: "JoinPublicationExistingUser",
  components: { AvatarImage, PoweredByInspiration },
  data() {
    return {
      DEFAULT_USER_AVATAR,
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["userData"]),
    ...mapState(useLoginSignupStore, ["isLoading"]),
    ...mapWritableState(useLoginSignupStore, [
      "userAuthEmail",
      "userFlowSteps",
      "signupErrorMessage",
      "lastLoggedInUsers",
    ]),
  },
  created() {
    if (Object.keys(this.userData).length > 0) {
      this.lastLoggedInUsers = { [this.userData.user_id]: this.userData };
    }
  },
  mounted() {
    this.signupErrorMessage = "";
  },
  methods: {
    finalizeLogin(user) {
      if (this.isLoading) {
        return;
      }
      if (this.userData.user_id !== user.user_id) {
        this.userAuthEmail = user.email_data.email_address;
        this.userFlowSteps.push(PASSWORD_FORM);
      } else {
        useLoginSignupStore().authenticateLoginWithInspiration();
      }
    },
    useDifferentEmail() {
      this.userFlowSteps = [EMAIL_FORM];
    },
  },
};
</script>
